import { useState } from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { ConsentCheckbox } from './ConsentCheckbox';
import { recordConsent, getLegalDocument } from '../../api/legal';

export function ReconsentModal({ open, documents, onComplete }) {
  const [checked, setChecked] = useState({});
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const allChecked = documents?.length > 0 && documents.every(d => checked[d.slug]);

  const handleConfirm = async () => {
    if (!allChecked) return;
    setSaving(true);
    setError('');
    try {
      // Backend documents listesinde id yok — slug ile en güncel versiyonu çekip ID'yi al
      for (const doc of documents) {
        const detail = await getLegalDocument(doc.slug);
        await recordConsent({
          document_id: detail.document.id,
          context: 'reconsent',
        });
      }
      onComplete();
    } catch (err) {
      setError('Onay kaydedilemedi. Lütfen tekrar deneyin.');
    } finally {
      setSaving(false);
    }
  };

  if (!open || !documents?.length) return null;

  return (
    <Modal open={open} onClose={() => {}} title="Sözleşmelerimiz Güncellendi" size="md">
      <p className="text-sm text-slate-600 mb-5">
        Aşağıdaki sözleşmelerimiz güncellendi. Devam etmek için yeni versiyonları onaylamanız gerekiyor.
      </p>

      <div className="space-y-3 mb-6">
        {documents.map(doc => (
          <ConsentCheckbox
            key={doc.slug}
            document={doc}
            checked={!!checked[doc.slug]}
            onChange={(v) => setChecked(prev => ({ ...prev, [doc.slug]: v }))}
          />
        ))}
      </div>

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg p-3 mb-4">
          {error}
        </div>
      )}

      <div className="flex justify-end">
        <Button
          onClick={handleConfirm}
          disabled={!allChecked}
          loading={saving}
        >
          Onayla ve Devam Et
        </Button>
      </div>
    </Modal>
  );
}
